/**
 * hiprint 元素类型配置
 * 提供自定义元素类型的默认配置，用于创建可拖拽的元素组
 */

/**
 * 自定义元素类型配置
 * key: 元素类型标题 (与模板中的 printElementType.title 对应)
 * value: { type: 元素类型, options: 默认选项, data: 默认数据 }
 */
const CUSTOM_ELEMENT_TYPES = {
  // 公司信息
  '公司名称': { 
    type: 'text', 
    data: '@公司名称',
    options: { field: 'companyName', testData: '@公司名称', fontSize: 10.5, lineHeight: 13.5 } 
  },
  '联系人': { 
    type: 'text', 
    data: '@联系人',
    options: { field: 'companyContacts', testData: '@联系人', fontSize: 10.5, lineHeight: 13.5 } 
  },
  '公司地址': { 
    type: 'text', 
    data: '@公司地址',
    options: { field: 'companyAddress', testData: '@公司地址', fontSize: 10.5, lineHeight: 13.5 } 
  },
  '公司电话': { 
    type: 'text', 
    data: '@公司电话',
    options: { field: 'companyTel', testData: '@公司电话', fontSize: 10.5, lineHeight: 13.5 } 
  },
  '公司传真': { 
    type: 'text', 
    data: '@公司传真',
    options: { field: 'companyFax', testData: '@公司传真', fontSize: 10.5, lineHeight: 13.5 } 
  },
  '销售协议': { 
    type: 'text', 
    data: '@销售协议',
    options: { field: 'companySaleAgreement', testData: '@销售协议', fontSize: 10.5, lineHeight: 13.5 } 
  },
  
  // 单据主体（通用）
  '单据抬头': { 
    type: 'text', 
    data: '@单据抬头',
    options: { field: 'billTitle', testData: '@单据抬头', hideTitle: true, width: 350, height: 15, fontSize: 15 } 
  },
  '单据日期': { 
    type: 'text', 
    data: '@单据日期',
    options: { field: 'operTimeStr', testData: '@单据日期', fontSize: 10.5, lineHeight: 13.5 } 
  },
  '单据编号': { 
    type: 'text', 
    data: '@单据编号',
    options: { field: 'number', testData: '@单据编号', fontSize: 10.5, lineHeight: 13.5 } 
  },
  '备注': { 
    type: 'text', 
    data: '@备注',
    options: { field: 'remark', testData: '@备注', fontSize: 10.5, lineHeight: 13.5 } 
  },
  '合计数量': { 
    type: 'text', 
    data: '@合计数量',
    options: { field: 'billDetailAllAmount', testData: '@合计数量', fontSize: 10.5, lineHeight: 13.5 } 
  },
  '制单人': { 
    type: 'text', 
    data: '@制单人',
    options: { field: 'creatorName', testData: '@制单人', fontSize: 10.5, lineHeight: 13.5 } 
  },
  
  // 单据主体（各单据类型特有）
  '请购部门': { 
    type: 'text', 
    data: '@请购部门',
    options: { field: 'organName', testData: '@请购部门', fontSize: 10.5, lineHeight: 13.5 } 
  },
  '供应商': { 
    type: 'text', 
    data: '@供应商',
    options: { field: 'supplierName', testData: '@供应商', fontSize: 10.5, lineHeight: 13.5 } 
  },
  '客户': { 
    type: 'text', 
    data: '@客户',
    options: { field: 'organName', testData: '@客户', fontSize: 10.5, lineHeight: 13.5 } 
  },
  '入库仓库': { 
    type: 'text', 
    data: '@入库仓库',
    options: { field: 'deptName', testData: '@入库仓库', fontSize: 10.5, lineHeight: 13.5 } 
  },
  '出库仓库': { 
    type: 'text', 
    data: '@出库仓库',
    options: { field: 'deptName', testData: '@出库仓库', fontSize: 10.5, lineHeight: 13.5 } 
  },
  '调出仓库': { 
    type: 'text', 
    data: '@调出仓库',
    options: { field: 'deptName', testData: '@调出仓库', fontSize: 10.5, lineHeight: 13.5 } 
  },
  '调入仓库': { 
    type: 'text', 
    data: '@调入仓库',
    options: { field: 'toDeptName', testData: '@调入仓库', fontSize: 10.5, lineHeight: 13.5 } 
  },
  
  // 单据明细
  '表格信息': { 
    type: 'table', 
    data: '',
    options: { field: 'table', testData: '', fontSize: 10.5, lineHeight: 13.5 } 
  },
  
  // 其他通用名称映射
  '表格明细': { 
    type: 'table', 
    data: '',
    options: { field: 'table', testData: '', fontSize: 10.5, lineHeight: 13.5 } 
  },
  
  // 其他（通用元素）
  '条形码': { 
    type: 'text', 
    data: '1234567890',
    options: { field: 'barcode', testData: '1234567890', textType: 'barcode' } 
  },
  '二维码': { 
    type: 'text', 
    data: 'https://example.com',
    options: { field: 'qrcode', testData: 'https://example.com', textType: 'qrcode' } 
  },
  'Logo': { 
    type: 'image', 
    data: '',
    options: { field: 'logo', testData: '' } 
  },
  '图片': { 
    type: 'image', 
    data: '',
    options: { field: 'image', testData: '' } 
  },
  '文本': { 
    type: 'text', 
    data: '自定义文本',
    options: { field: 'customText', testData: '自定义文本' } 
  },
  '长文本': { 
    type: 'longText', 
    data: '长文本内容',
    options: { field: 'longText', testData: '长文本内容' } 
  },
  '横线': { 
    type: 'hline', 
    data: '',
    options: {} 
  },
  '竖线': { 
    type: 'vline', 
    data: '',
    options: {} 
  },
  '矩形': { 
    type: 'rect', 
    data: '',
    options: {} 
  },
  '椭圆': { 
    type: 'oval', 
    data: '',
    options: {} 
  }
}

/**
 * 根据 type 获取默认配置
 * @param {string} type - 元素类型
 * @returns {Object} 默认配置
 */
function getDefaultTypeConfig(type) {
  const defaultConfigs = {
    'text': { type: 'text', data: '', options: { fontSize: 10.5, lineHeight: 13.5 } },
    'longText': { type: 'longText', data: '', options: { fontSize: 10.5, lineHeight: 13.5 } },
    'table': { type: 'table', data: '', options: { fontSize: 10.5, lineHeight: 13.5 } },
    'image': { type: 'image', data: '', options: {} },
    'hline': { type: 'hline', data: '', options: {} },
    'vline': { type: 'vline', data: '', options: {} },
    'rect': { type: 'rect', data: '', options: {} },
    'oval': { type: 'oval', data: '', options: {} },
    'barcode': { type: 'text', data: '1234567890', options: { textType: 'barcode' } },
    'qrcode': { type: 'text', data: 'https://example.com', options: { textType: 'qrcode' } }
  }
  
  return defaultConfigs[type] || { type: type || 'text', data: '', options: {} }
}

/**
 * 根据元素标题获取完整的元素配置
 * @param {string} title - 元素标题
 * @param {string} type - 元素类型（可选）
 * @returns {Object} 元素配置
 */
export function getElementTypeByTitle(title, type) {
  // 先检查自定义元素
  if (CUSTOM_ELEMENT_TYPES[title]) {
    const customType = CUSTOM_ELEMENT_TYPES[title]
    return {
      title: title,
      type: customType.type,
      data: customType.data,
      options: customType.options
    }
  }
  
  // Fallback: 根据 type 返回默认配置
  const defaultConfig = getDefaultTypeConfig(type)
  return {
    title: title,
    type: defaultConfig.type,
    data: defaultConfig.data,
    options: defaultConfig.options
  }
}

/**
 * 注册自定义元素类型到 hiprint（保留兼容性）
 * 现在只需要打印一条日志，因为元素是通过 hiprint-register.js 直接添加的
 * @param {Object} hiprint - hiprint 实例
 */
export function registerCustomElementTypes(hiprint) {
  console.log('[hiprint-provider] 元素类型配置已加载，元素注册由 hiprint-register.js 负责')
  return true
}

export default {
  registerCustomElementTypes,
  getElementTypeByTitle,
  CUSTOM_ELEMENT_TYPES
}
